import AddOffer from "../../../Components/Pricings/Offers/AddOffer"
export default function CreateOffer(){
    return(
        <AddOffer/>
    )
}